import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var PriceIncludesInfoBlock = function PriceIncludesInfoBlock(_ref) {
  var cottage = _ref.cottage;
  var inclAttributes = cottage.attributes.filter(function (attribute) {
    return attribute.name === "Linnen incl." || attribute.name === "Elektra incl.";
  }).map(function (incl) {
    if (incl.name === "Linnen incl.") {
      return "Linnen";
    }

    if (incl.name === "Elektra incl.") {
      return "Elektra";
    }
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h6", {
      children: "Prijs is inclusief"
    }), /*#__PURE__*/_jsxs("p", {
      className: "text-sm price-includes-info-block",
      children: [/*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("i", {
          className: "fa fa-check text-primary"
        }), " Boekingskosten", " "]
      }), inclAttributes.map(function (incl) {
        return /*#__PURE__*/_jsxs("span", {
          children: [" ", /*#__PURE__*/_jsx("i", {
            className: "fa fa-check text-primary inclusive"
          }), " ", incl]
        }, incl);
      })]
    })]
  });
};

export default PriceIncludesInfoBlock;